<template>
  <v-container v-if="['A'].find(el=>el==store.state.user.groupe)" fluid class="pa-6">
    <v-card elevation="2" class="mx-auto" max-width="1200">
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2">mdi-account-group</v-icon>
        Gestion des utilisateurs
        <v-spacer />
        <v-btn color="primary" prepend-icon="mdi-plus" @click="openCreate">
          Nouvel utilisateur
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <!-- Recherche + refresh -->
        <v-row class="mb-2">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              label="Rechercher"
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              density="compact"
              hide-details
              clearable
            />
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end align-center">
            <v-btn
              icon="mdi-refresh"
              variant="text"
              :loading="loading"
              @click="loadUsers"
            />
          </v-col>
        </v-row>

        <!-- Tableau -->
        <v-data-table
          :headers="headers"
          :items="users"
          :search="search"
          :loading="loading"
          item-key="id"
          class="elevation-1"
          density="comfortable"
        >
          <template #item.actif="{ item }">
            <v-chip
              :color="item.actif ? 'success' : 'grey'"
              size="small"
              label
            >
              {{ item.actif ? 'Actif' : 'Inactif' }}
            </v-chip>
          </template>

          <template #item.actions="{ item }">
            <v-btn
              icon="mdi-pencil"
              size="small"
              variant="text"
              color="primary"
              @click="openEdit(item)"
            />
            <v-btn
              icon="mdi-delete"
              size="small"
              variant="text"
              color="error"
              @click="askDelete(item)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- ============ Dialog création / édition ============ -->
    <v-dialog v-model="dialog" max-width="640" persistent>
      <v-card>
        <v-card-title class="text-h6">
          {{ edited.id ? "Modifier l'utilisateur" : 'Nouvel utilisateur' }}
        </v-card-title>
        <v-divider />

        <v-card-text>
          <v-form ref="formRef" v-model="valid" @submit.prevent>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="edited.name"
                  label="Prénom *"
                  :rules="[r.required]"
                  variant="outlined"
                  density="compact"
                />
              </v-col>
              <v-col cols="12" md="6">
                 <v-text-field
                 label="Username *"
                  v-model="edited.username"
                  :rules="[r.required]"
                  variant="outlined"
                  density="compact"
                />
                
               
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field

                  v-model="edited.email"
                  label="Email *"
                  :rules="[r.required, r.email]"
                  variant="outlined"
                  density="compact"
                  @change="edited.username=(edited.email?edited.email.split('@')[0]:'')"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  density="compact"
                  v-model="edited.password"
                  :label="
                    edited.id
                      ? 'Mot de passe (laisser vide pour ne pas changer)'
                      : 'Mot de passe *'
                  "
                  :type="showPwd ? 'text' : 'password'"
                  :append-inner-icon="showPwd ? 'mdi-eye-off' : 'mdi-eye'"
                  :rules="edited.id ? [] : [r.required, r.min6]"
                  variant="outlined"
                  @click:append-inner="showPwd = !showPwd"
                />
              </v-col>
              

              <v-col cols="12" md="4">
                <v-select
                  v-model="edited.language"
                  label="Langue"
                  :items="['fr', 'nl', 'en']"
                  variant="outlined"
                  density="compact"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="edited.etablissement"
                  label="Établissement *"
                  :rules="[r.required]"
                  variant="outlined"
                  density="compact"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="edited.groupe"
                  label="Groupe"
                  :items="['A', 'N', 'U']"
                  variant="outlined"
                  density="compact"
                />
              </v-col>

              <v-col v-if="edited.id" cols="12">
                <v-switch
                  v-model="edited.actif"
                  label="Compte actif"
                  color="success"
                  density="compact"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialog = false">Annuler</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">
            {{ edited.id ? 'Enregistrer' : 'Créer' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ============ Dialog suppression ============ -->
    <v-dialog v-model="confirmDelete" max-width="420">
      <v-card>
        <v-card-title class="text-h6">
          Confirmer la suppression
        </v-card-title>
        <v-card-text>
          Supprimer définitivement
          <b>{{ toDelete?.name }}</b> ({{ toDelete?.username }}) ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="confirmDelete = false">Annuler</v-btn>
          <v-btn color="error" :loading="deleting" @click="doDelete">
            Supprimer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ============ Snackbar ============ -->
    <v-snackbar v-model="snack.show" :color="snack.color" timeout="3000">
      {{ snack.text }}
    </v-snackbar>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import store from '@/store'
/* ------------------------------------------------------------------
 * Config
 * ------------------------------------------------------------------ */
const API = 'https://my.edisac.com/api/users'
// const API = 'http://localhost:8282/apimyedisac/users'

/* ------------------------------------------------------------------
 * State
 * ------------------------------------------------------------------ */
const users         = ref([])
const loading       = ref(false)
const saving        = ref(false)
const deleting      = ref(false)
const search        = ref('')
const dialog        = ref(false)
const confirmDelete = ref(false)
const showPwd       = ref(false)
const valid         = ref(false)
const formRef       = ref(null)
const toDelete      = ref(null)

const snack = ref({ show: false, text: '', color: 'success' })
const notify = (text, color = 'success') => {
  snack.value = { show: true, text, color }
}

const emptyUser = () => ({
  id: null,
  name: '',
  username: '',
  password: '',
  language: 'fr',
  etablissement: 'DEPO',
  groupe: 'A',
  email: '',
  actif: true
})
const edited = ref(emptyUser())

const headers = [
  { title: 'Nom',           key: 'name' },
  { title: 'Identifiant',   key: 'username' },
  { title: 'Email',         key: 'email' },
  { title: 'Établissement', key: 'etablissement' },
  { title: 'Langue',        key: 'language' },
  { title: 'Groupe',        key: 'groupe' },
  { title: 'Statut',        key: 'actif' },
  { title: 'Actions',       key: 'actions', sortable: false, align: 'end' }
]

/* ------------------------------------------------------------------
 * Règles de validation
 * ------------------------------------------------------------------ */
const r = {
  required: v => !!v || 'Champ requis',
  min6:     v => (v && v.length >= 6) || 'Min 6 caractères',
  email:    v => /.+@.+\..+/.test(v) || 'Email invalide'
}

/* ------------------------------------------------------------------
 * CRUD
 * ------------------------------------------------------------------ */
const loadUsers = async () => {
  loading.value = true
  try {
    const { data } = await axios.get(API,{
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        }
    })
    if (data.statut === 'ok') {
      users.value = data.users || []
    } else {
      notify(data.message || 'Erreur de chargement', 'error')
    }
  } catch (e) {
    notify(e.response?.data?.message || 'Erreur de chargement', 'error')
  } finally {
    loading.value = false
  }
}

const openCreate = () => {
  edited.value = emptyUser()
  dialog.value = true
}

const openEdit = (item) => {
  edited.value = { ...item, password: '' }
  dialog.value = true
}

const save = async () => {
  console.log('test');
  
  // const { valid: ok } = await formRef.value.validate()
  // if (!ok) return

  saving.value = true
  try {
    const payload = { ...edited.value }
    if (!payload.password) delete payload.password

    const token = localStorage.getItem('token')
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
      }
    }
    console.log(payload);
    
    let data
    if (edited.value.id) {
      ;({ data } = await axios.put(`${API}/${edited.value.id}`, payload, config))
    } else {
      ;({ data } = await axios.post(API, payload, config))
    }

    if (data.statut === 'ok') {
      notify(edited.value.id ? 'Utilisateur mis à jour' : 'Utilisateur créé')
      dialog.value = false
      loadUsers()
    } else {
      notify(data.message || 'Erreur', 'error')
    }
  } catch (e) {
    notify(e.response?.data?.message || 'Erreur', 'error')
  } finally {
    saving.value = false
  }
}

const askDelete = (item) => {
  toDelete.value = item
  confirmDelete.value = true
}

const doDelete = async () => {
  deleting.value = true
  try {
    const token = localStorage.getItem('token')
    const { data } = await axios.delete(`${API}/${toDelete.value.id}`, {
            headers: { 'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        }
    })
    if (data.statut === 'ok') {
      notify('Utilisateur supprimé')
      confirmDelete.value = false
      loadUsers()
    } else {
      notify(data.message || 'Erreur', 'error')
    }
  } catch (e) {
    notify(e.response?.data?.message || 'Erreur', 'error')
  } finally {
    deleting.value = false
  }
}

/* ------------------------------------------------------------------
 * Lifecycle
 * ------------------------------------------------------------------ */
onMounted(loadUsers)
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
}
</style>